import { Form, Formik } from "formik";
import TextInput from "../UI/TextInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Callout from "../UI/Callout";
import { useState } from "react";
import { handleAPIError } from "../../utils/index.jsx";
import { sanitizeValues } from "../../models/utils";
import moment from "moment/moment";

export default function PromosForm({ promo, onSubmit }) {
  const [error, setError] = useState("");

  async function submitHandler(values) {
    setError("");
    try {
      await onSubmit({
        ...promo,
        ...sanitizeValues(values),
        montant_a_payer: 0,
        montant_total: 0,
        autoapply: false,
        is_public: true,
        creation_date: moment(),
      });
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  return (
    <Formik
      initialValues={{ code: promo.code + " (copie)" }}
      enableReinitialize={true}
      onSubmit={submitHandler}
    >
      <Form>
        <TextInput
          type="text"
          label={"Code promo"}
          name="code"
          placeholder="QALIMO20"
          mandatory
          className={"marginT10"}
        />
        <div className="text-right">
          <FormikSubmitButton className={"marginL10 marginB20"}>
            Valider
          </FormikSubmitButton>
        </div>
        <Callout variant="danger">{error}</Callout>
      </Form>
    </Formik>
  );
}
